import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTriggersDaysData } from "../../../redux/plans-reducers/plansSlice";
import { NoPic } from "../../../exports/Images";
import { CheckCircleIcon, XCircleIcon } from "../../../images/icons/icons";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";

const TriggerDays = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const { triggersDays, triggersDaysLoading, triggersDaysError } = useSelector(
    (state) => state.plans
  );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    ren_unp_id: rowData?.uid || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  const getTriggersDaysData = (filters) => {
    dispatch(
      fetchTriggersDaysData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    if (filters?.ren_unp_id) {
      getTriggersDaysData(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (
      !triggersDaysLoading &&
      !triggersDaysError &&
      triggersDays?.status &&
      triggersDays?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: triggersDays.data,
        pagination:
          triggersDays?.pagination?.length > 0 ? triggersDays.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [triggersDays, triggersDaysLoading, triggersDaysError]);

  console.log(allDatas?.allData);

  return (
    <div className="form-container">
      <div className="formContainer">
        {triggersDaysLoading ? (
          <ReactVortoxSpinner />
        ) : allDatas?.allData?.length > 0 ? (
          allDatas.allData?.map((formInput, index) => (
            <React.Fragment key={index}>
              <div className="formInputsGrid fourGridSystem">
                <div className="formInputBox">
                  <label htmlFor={`days`} className={`formInputLabel `}>
                    Day
                  </label>

                  <input
                    type="text"
                    className={`formInput`}
                    name="days"
                    value={formInput.days}
                    disabled
                  />
                </div>

                {formInput.cashback && (
                  <div className="formInputBox">
                    <label htmlFor={`cashback`} className={`formInputLabel `}>
                      Cashback
                    </label>

                    <input
                      type="text"
                      className={`formInput`}
                      name="cashback"
                      value={formInput.cashback}
                      disabled
                    />
                  </div>
                )}

                {formInput.extend_days && (
                  <div className="formInputBox">
                    <label
                      htmlFor={`extend_days`}
                      className={`formInputLabel `}>
                      extend days
                    </label>

                    <input
                      type="text"
                      className={`formInput`}
                      name="extend_days"
                      value={formInput.extend_days}
                      disabled
                    />
                  </div>
                )}

                {formInput.voucher && (
                  <div className="formInputBox">
                    <label htmlFor={`voucher`} className={`formInputLabel `}>
                      voucher
                    </label>

                    <input
                      type="text"
                      className={`formInput`}
                      name="voucher"
                      value={formInput.voucher}
                      disabled
                    />
                  </div>
                )}

                {formInput?.offer_goodies?.length > 0 && (
                  <div className="formInputBox span4">
                    <label
                      htmlFor={`offer_goodies`}
                      className={`formInputLabel`}>
                      Goodies
                    </label>

                    <div className="gym-benefits-container disabled">
                      {formInput?.offer_goodies?.map((goods, index) => {
                        return (
                          <div className="gym-benefit-box" key={index}>
                            <p className="gym-benefit-label">
                              <b className="underline">{goods?.name || "NA"}</b>
                              <br />
                              {goods?.claim_at_gym
                                ? "Claim at gym"
                                : "Claim online"}{" "}
                              {goods?.claim_at_gym ? (
                                <CheckCircleIcon />
                              ) : (
                                <XCircleIcon />
                              )}
                            </p>
                            <div className="horizontal-gay-line"></div>
                            <img
                              src={goods?.image || NoPic}
                              alt={goods?.name || "N/A"}
                              className="gym-benefit-image"
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              <div className="formInputsGrid fourGridSystem">
                <div className="formInputBox span2">
                  <label htmlFor={`push_content`} className={`formInputLabel `}>
                    Push Content
                  </label>

                  <textarea
                    name="push_content"
                    className={`formInput`}
                    value={formInput.push_content}
                    disabled></textarea>
                </div>

                <div className="formInputBox span2">
                  <label
                    htmlFor={`email_content`}
                    className={`formInputLabel `}>
                    Email Content
                  </label>

                  <textarea
                    name="email_content"
                    className={`formInput`}
                    value={formInput.email_content}
                    disabled></textarea>
                </div>
              </div>

              <div className="formInputsGrid fourGridSystem mt15 mb15">
                <div className="grayLine span4"></div>
              </div>
            </React.Fragment>
          ))
        ) : (
          <div className="noDataFound">No Data Found</div>
        )}
      </div>
    </div>
  );
};

export default TriggerDays;
